import { ContactForm } from "@/components/site/ContactForm";

export const ContactSection = ({ c, interest, setInterest, products }) => (
  <section id="contact" aria-labelledby="contact-title" data-track-section="contact" data-nexus-s=".85" data-nexus-dim=".30" className="section contact">
    <div className="wrap contact-wrap">
      <div className="section-head reveal">
        <p className="kicker">{c.kicker}</p>
        <h2 id="contact-title" className="section-title">{c.title}</h2>
        <p className="lede">{c.lede}</p>
      </div>
      <div className="contact-body">
        <ContactForm c={c} interest={interest} setInterest={setInterest} products={products} />
      </div>
    </div>
  </section>
);
